import { Component, OnInit } from '@angular/core';
import { ForecastGroup, ListDto, ScenarioAdjustmentService, ScenarioAdjustmentTableDto, ScenarioAdjustmentTargetDto, ScenarioDto } from './adjustment.service';
import { NotificationService } from 'src/app/services/notification.service';
import { LoadingIndicationService } from 'src/app/services/loading-indication.service';
import { FiltersOperator } from 'src/app/widgets/filters/api/filters-operator.api';
import { SelectStatementOptions } from 'src/app/models/select-statement-options.model';

@Component({
    selector: 'app-adjustment',
    templateUrl: './adjustment.component.html',
    styleUrls: ['./adjustment.component.scss'],
    standalone: false
})
export class AdjustmentComponent implements OnInit {

  public scenarios: ScenarioDto[] = [];
  public adjTargets: ScenarioAdjustmentTargetDto[] = [];

  public selectedTargetTableName: string = "";
  public selectedScenarioId: number;

  public adjustmentName: string = "";

  public adjTargetFields: ListDto[] = [];
  public selectedTargetField: string = "";

  public groups: ForecastGroup[] = [];
  public selectedTargetGroup: string = "";

  public adjTableData: ScenarioAdjustmentTableDto[] = [];
  public editedAdjTableData: ScenarioAdjustmentTableDto[] = [];

  public existingAdjustmentNames: string[] = [];
  public showConfirmPopup = false;

  public adjustmentFiltersOperator: FiltersOperator = new FiltersOperator(
    new SelectStatementOptions(
      {
        baseSelectStatementId: 10079,
        selectionSetId: 127
      }
    )
  );

  constructor(
    private adjustmentService: ScenarioAdjustmentService,
    private notificationService: NotificationService
  ) { }

  public getExistingAdjustmentNames() {
    this.adjustmentService.getScenarioAdjustmentNames().subscribe(res => {
      this.existingAdjustmentNames = res;
    });
  }

  public getScenarios() {
    this.adjustmentService.getAllScenarios().subscribe(res => {
      this.scenarios = res;
    });
  }

  public getScenarioAdjustmentTargets() {
    this.adjustmentService.getScenarioAdjustmentTargets().subscribe(res => {
      this.adjTargets = res;
    });
  }

  public getScenarioAdjustmentTargetFields() {
    this.adjustmentService.getScenarioAdjustmentTargetFields(this.selectedTargetTableName).subscribe(res => {
      this.adjTargetFields = res;
    });
  }

  public getScenarioAdjustmentTableData() {
    this.adjustmentService.getScenarioAdjustmentTableData(this.selectedTargetGroup, this.selectedTargetField, this.adjustmentFiltersOperator.appliedFilters).subscribe(res => {
      this.adjTableData = this.adjustmentService.convertSelectStatementDataToAdjTableData(this.selectedTargetGroup, this.selectedTargetField, res);
    });
  }

  private getForecastGroups() {
    this.adjustmentService.getForecastGroups().subscribe(res => {
      this.groups = res;
      console.log(res);
      if (res != null && res != undefined && res.length > 0 && !this.selectedTargetGroup) {
        this.selectedTargetGroup = res[0].fieldName;
      }
    });
  }

  ngOnInit(): void {
    this.getScenarios();
    this.getScenarioAdjustmentTargets();
    this.getForecastGroups();
    this.getExistingAdjustmentNames();

    this.adjustmentFiltersOperator.load();
    this.adjustmentFiltersOperator.onFiltersApplied.subscribe({
      next: (res) => {
        this.adjustmentFiltersOperator.load();
        this.getScenarioAdjustmentTableData();
      }
    });
  }

  onRowUpdated(event) {
    event.data.final = event.data.original + event.data.original * event.data.adjustment / 100;
    this.editedAdjTableData.push(event.data);
  }

  saveAdjustmentChanges() {
    this.adjustmentService.saveScenarioAdjustmentAndData(this.adjTableData,
      this.adjustmentName, this.selectedTargetTableName, this.selectedTargetField)
      .subscribe(res => {
        if (res) {
          this.notificationService.success("Changes saved successfully!", 2000);
        } else {
          this.notificationService.success("Changes saved successfully!", 2000);
        }
      });
  }

  preSavePopupQuery() {
    if (this.existingAdjustmentNames.findIndex(x => x == this.adjustmentName) > -1) {
      this.showConfirmPopup = true;
    } else {
      this.saveAdjustmentChanges();
    }
  }

  cancelChanges() {
    this.showConfirmPopup = false;
  }

  adjNameValueChanged(e) {
    this.adjustmentName = e.value;
  }

  targetTableChanged(e) {
    this.getScenarioAdjustmentTargetFields();
  }

  targetFieldChanged(e) {
    this.getScenarioAdjustmentTableData();
  }

  forecastGroupChanged(e) {
    this.selectedTargetGroup = e.selectedItem.fieldName;
    if (this.selectedTargetField != "") {
      this.getScenarioAdjustmentTableData();
    }
  }

}
